import { apiGet, apiDelete, apiPost, apiPut } from './api_call/api_methods'

export const fetchKonnektForms = async (device_id, form_type) => {
    return apiGet({ endpoint: `${process.env.REACT_APP_API_URL}/konnekt/forms?device_id=${device_id}&form_type=${form_type}`, error_message: "Failed to fetch admins." });
};

export const PostKonnektForm = async (data) => {
    return apiPost({ endpoint: `${process.env.REACT_APP_API_URL}/konnekt/create_konnekt_form`, body: data, successMessage: "Form saved successfully!", errorMessage: "Failed to save form." })
};